module.exports = new __parcel__URL__("broccoli.fa9fd55e.svg").toString();